import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import MasterFSPSearchForm from "./MasterFSPSearchForm";

const MasterFSPSearchPanel = () => {
    const MASTER_FSP_CONSTANT = MasterFSPMaintenanceConstant;
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const { searchCriteria } = masterFSPState;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const resetButtonClicked = useCallback(() => {
        masterFSPVM.onSearchCriteriaResetClick();
    }, [masterFSPVM]);

    const searchButtonClicked = useCallback(() => {

        setIsLoading(true);
        masterFSPVM.searchMasterFSP(searchCriteria).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, [searchCriteria, masterFSPVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{MASTER_FSP_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={masterFSPVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        {/* Stack Form Start */}
                        <MasterFSPSearchForm />
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked()} />
            </SidebarActionBar>
        </div>
    );
}

export default MasterFSPSearchPanel;
